document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('[data-filter-form]');
  if (!form) return;

  var toggle = form.querySelector('[data-filter-toggle]');
  var panel = form.querySelector('[data-filter-panel]');
  var closers = form.querySelectorAll('[data-filter-close]');
  var applyBtn = form.querySelector('[data-filter-apply]');
  var sortSelect = form.querySelector('[data-sort-select]');

  function openPanel() {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      if (panel.classList.contains('is-open')) closePanel(); else openPanel();
    });
  }
  closers.forEach(function (el) { el.addEventListener('click', closePanel); });
  if (applyBtn) applyBtn.addEventListener('click', function () { form.requestSubmit(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) closePanel();
  });

  /* Auto-submit on any filter change so results update without an extra click */
  form.querySelectorAll('[data-filter-input]').forEach(function (input) {
    input.addEventListener('change', function () { form.requestSubmit(); });
  });

  if (sortSelect) {
    sortSelect.addEventListener('change', function () { form.requestSubmit(); });
  }
});
